import React, { useState } from "react";
import { PiXFill } from "react-icons/pi";
import Button from "../../../button/Button";
import { useReactToPrint } from "react-to-print";

const { forwardRef, useRef, useImperativeHandle } = React;

const PrintAddressModal = forwardRef(({ printData }, ref) => {
  const [showModal, setShowModal] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
    },
    afterSubmit() { },
  }));

  const printAddressRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => printAddressRef.current,
    contentRef: printAddressRef,
    documentTitle: "print address",
    bodyClass: "rtlDir",
    onAfterPrint: () => {
      console.log("Printed PDF successfully!");
      setShowModal(false);
    },
  });

  const chunkArray = (array, chunkSize) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  };

  return (
    <>
      <div
        className={`fixed top-0 right-0 w-full h-full bg-black/40 transition-all z-30  ${!showModal && "hidden"
          }`}
      ></div>
      <div
        className={`w-[1024px] py-4 bg-white mt-4 shadow-md z-40 rounded-3xl p-4 transition-all fixed top-0 right-[50%] mr-[-512px] opacity-0 invisible ${showModal && "!mt-20 !opacity-100 !visible"
          }`}
      >
        <div className="w-full px-6 flex items-center justify-between py-4 border-b-2">
          <h4>پرینت آدرس سفارشات</h4>
          <PiXFill
            onClick={() => setShowModal(false)}
            size={30}
            className="text-red-400 transition-all hover:text-red-600 cursor-pointer"
          />
        </div>
        <div className="w-full py-2 text-center max-h-[360px] overflow-y-scroll">
          <div ref={printAddressRef} className="w-full px-4">
            {printData?.length
              ? chunkArray(printData, 3).map((group, index) => (
                <div key={index} className="page-break">
                  {group.map((item, idx) => (
                    <div key={idx} className="w-11/12 mx-auto overflow-hidden">
                      <div className="my-4 border-b boder-gray-900 py-2"></div>
                      <div className="w-full py-4">
                        <h3 className="px-2 text-gray-800">اطلاعات مشتری</h3>
                        <div className="flex flex-col gap-3 text-gray-700 py-4">
                          <div className="flex px-4 items-center gap-4">
                            <p className="w-6/12 text-md">
                              نام و نام خانوادگی : {item?.name}
                            </p>
                            <p className="w-6/12 text-md">شماره تماس : {item?.mobile}</p>
                          </div>
                          <div className="flex px-4 items-center gap-4">
                            <p className="w-6/12 text-md">کد پستی : {item?.postcode}</p>
                            <p className="w-6/12 text-md">استان : {item?.province}</p>
                          </div>
                          <div className="flex px-4 items-center gap-4">
                            <p className="w-6/12 text-md">شهر : {item?.city}</p>
                            <p className="w-6/12 text-md">آدرس : {item?.address}</p>
                          </div>
                          <div className="flex px-4 items-center gap-4">
                            <p className="w-6/12 text-md">
                              شماره سفارش : {item?.trackingCode}
                            </p>
                            <p className="w-6/12 text-md">
                              توضیحات : {item?.description || "-"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ))
              : null}
          </div>
        </div>
        <div className="flex gap-2 justify-end w-full">
          <Button
            onClick={() => setShowModal(false)}
            text={"بازگشت"}
            color={"primary"}
            type="button"
          />
          <Button
            onClick={handlePrint}
            text={"پرینت"}
            color={"success"}
          />
        </div>
      </div>
    </>
  );
});
export default PrintAddressModal;
